var map = {
	"./de/general4/slide1.svg": 190969,
	"./en/general4/slide1.svg": 788029,
	"./es/general4/slide1.svg": 265948,
	"./fr/general4/slide1.svg": 130612,
	"./nl/general4/slide1.svg": 261598,
	"./pt/general4/slide1.svg": 244376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354367;